module.exports = __webpack_public_path__ + "img/lighting.d2a0d639.svg";